import { render, staticRenderFns } from "./CustomParkPositionSettings.vue?vue&type=template&id=680b2f65&"
import script from "./CustomParkPositionSettings.vue?vue&type=script&lang=ts&"
export * from "./CustomParkPositionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VTextField})
